<template>
    <div class="">
         <div class="row no-gutters py-2 mb-3 ml-3">
			<div class="col-sm-6 pr-3 ">
				<h4 class="atlhr-dashboard-title mt-10">
					<span class="blue-title">GF</span> Settlement Applications
					<span>
						<a v-bind:href="pageurl">Dashboard</a>
						/ GF Settlement Applications
					</span>
				</h4>
			</div>
		</div>
        <b-overlay rounded="sm">
            <div class="row col-12 no-margin loan_approve_list">
                <div class="ibox col-md-12 border-0 ">
                    <div class="ibox-title dashboard_title company-form-box-title">
                        <h4 class="clearfix">
                            <span class="float-left">Settlement Applications<span class="title-sub-text"></span></span>
                            <span class="float-right">
                            </span>
                        </h4>
                    </div>
        
                    <div class="company-directory" v-if="custom_list.length>0">
                        <common-list  :pageurl="this.$api_url" :checkbox="checkbox"  :is_pf="is_n_pf" :is_approval_list="is_approval_list"  :is_action="is_action" :appended_column="appended_column" :key="list_key" :company_options="company_options" :employees="custom_list" :default_column="default_column" :primary_key="primary_key" v-on:childToParent="listReturn"></common-list>
                    </div>
                    <div v-else>

                        <div v-if="show_loader" class="list-no-data">
                            <span class="d-block text-center">Looking for relevant data..</span>
                            <img v-bind:src="$api_url+'/images/download-loader.svg'" class="loader-logo" width="100px"/>
                        </div>
                        <div v-else class="list-no-data">
                            Looks like there is no employee to show.
                        </div>
                        
                    </div>

                    <gf-settlement-form-quick-view-front :pageurl="pageurl" :settlement_id="settlement_id" :employee_id="employee_id"  :employee_name="employee_name" :quick_view="quick_view" :action_type="action_type" :key="settle_form_key" v-on:childToParent="detailsReturn"></gf-settlement-form-quick-view-front>

                </div>
            </div>
        </b-overlay>


    </div>
</template>


<script>
    
    export default{
        
        mounted() {
            
            this.showoverlay = false;
        },
        props: ['flg','pageurl'],
        components: {
           
        },
        data(){            
           
        
            return {
                
                
                custom_list:[],  /* Data List */
                default_column:['name','employee_code'], /* Default Column List */
                appended_column:[
                        
                    { value: "settlement_company_code", text: "Settlement ID",type: "text"},
                    { value: "settlement_type", text: "Settlement Type",type: "text"},
                    { value: "settlement_date", text: "Settlement Date",type: "date"},
                    { value: "settlement_amount", text: "Settlement Amount",type: "number"},
                    { value: "settlement_status", text: "Status",type: "text"},
                
                    
                    ],                   /* Appended Column List  and there title and type */
                primary_key:'settlement_id',  /* Primary is the unique key of the list this key will be returned if the row is clicked, 
                                            for employee list is employee_id, For loan list it is loan_id etc here it is employee_id*/
                company_options:[],         /* Company Filterable options */
                list_key:0,
                is_n_pf:1,
                show_loader:false,
                settlement_id:0,
                settle_form_key:0,
                employee_id:0,
                employee_name:0,
                show_approval:0,
                checkbox:1, 
                selected:[],
                is_approval_list:1,
                is_action:1,
                quick_view:0,
                action_type:"",

    
            }
        },
        methods:{
            detailsReturn:function()
            {
                this.getSettlementList();
            },
            listReturn:function(data)
            {
                
                if(data.action_id==1)
                {
                    this.settlement_id = 0;
                    var item  = this.custom_list.find(item => item.settlement_id === data.settlement_id); 
                    if(data.settlement_id > 0)
                    {
                        this.quick_view = 1;
                        this.action_type = "";
                        this.settlement_id = data.settlement_id;
                        this.employee_id = item.employee_id;
                        this.employee_name = item.name;
                        this.settle_form_key += 1;
                    }
                    console.log(data);
                }
                if(data.action_id==2)
                {
                    this.settlement_id = 0;
                    var item  = this.custom_list.find(item => item.settlement_id === data.settlement_id);
                    if(data.settlement_id > 0)
                    {
                        this.quick_view = 0;
                        this.action_type = "";
                        this.settlement_id = data.settlement_id;
                        this.employee_id = item.employee_id;
                        this.employee_name = item.name;
                        this.settle_form_key += 1;
                    }
                    console.log(data);
                } 
                else if(data.action_id==99)
                {
                    this.selected = data.selected;
                    
                    if(this.selected == '')
                    {
                        this.$bvToast.toast("No application selected", {title: 'Warning!',variant: 'warning',solid: true, toaster: "toaster: b-toaster-top-right"});
                    }   
                    else
                    {
                        this.exportApplicationData(this.selected);
                    }
                }   
            },
        
            
			formatMoney: function(amount)
            { 
                var money = Number(amount);
				var dec_points = 0;

                if(this.$atl_company_number_format == 'no')
                {
                    money = Math.round(money);
                    money = money.toLocaleString();
                }
                else
                { 
                    money = money.toLocaleString(); 
                    if(money=='NaN')
                    money = amount;
                    else
					{
						if(money.indexOf(".") < 0)
						{
							money = money+".00";
						}
						else
						{
							dec_points = money.length - money.indexOf('.') - 1;

							if(dec_points == 1)
							{
								money = money+"0";
							}
							else if(dec_points == 0)
							{
								money = money+"00";
							}
						}

                	}
				}
                
                return money;
            }, 
           
            exportApplicationData: function(ids)
            {
                if(!this.checkNet()) return false;
                let currentObj = this; 
                let formData = new FormData();
                formData.append('ids', ids);        
                this.showoverlay = true;
                axios.post(this.$api_url+'/pf/settlement/export-data', formData)
                .then(function (response) 
                {
                    var fileURL = response.data;
                    this.download_file(fileURL);
                    
                }.bind(this)).catch(function (error){currentObj.serverError(error);});

            },
            toMoney: function(amount)
            {
                if(amount !="0")
                {
                        if(!isNaN(amount))
                        {
                            var number = Number(amount);
                            return number;
                        }
                    var NumWithoutCommas = amount.replace(/,/g, ''); 
                    var number = Number(NumWithoutCommas).toFixed(2);
                    return number;
                }else
                    return 0;
            },
            
          
            getSettlementList: function()
            {

                console.log('what the fuck is happening');
                this.show_loader = true;
                let currentObj = this;                    
                let formData = new FormData();
                if(!this.checkNet()) return false;
                formData.append('list_type', 'all');
                axios.post(this.$api_url_front+'/gf/settlement/list', formData)
                .then(function (response) 
                {
                     
                    let temp_settle_list;
                    /* Assingning the Options */  

                    currentObj.company_options = Object.keys(response.data.options).map((key) => (response.data.options[key]));

                    /* Assingning the list */ 
                    temp_settle_list = Object.keys(response.data.employee_data).map((key) => (response.data.employee_data[key]));

                    console.log(temp_settle_list); 
                    /* Now if we have actions in this grid then we have to create an additional key in each row and assing the actions for each row accordingly */
                    
                    if(temp_settle_list.length > 0 )
                    {

                         
                        temp_settle_list.forEach(element => {
                            let dop = []; 
                                dop = dop.concat([{ label: 'Quick View' , value: 1 }]);

                                if(element.show_notification == 1)
                                {
                                    dop = dop.concat([{ label: 'Provide Approval' , value: 2 }]);
                                }

                                element.actions = dop; 
                            }); 
 
                          
                        
                    }
                    else
                    {
                        currentObj.blankmsg = "No employee found as leaver";
                    }
                    
                    currentObj.custom_list = temp_settle_list;
                    currentObj.list_key = currentObj.list_key + 1;
                    currentObj.show_loader = false;                       
                   
                    
                }.bind(this))
                .catch(function (error) 
                {
                    console.log(error);
                    currentObj.show_loader = false;
                });
                
            },
        },
        created: function(){
          this.getSettlementList();
        },
        computed: 
        {
            
        }
    }
</script>


<style scoped>
.demolistwrap2 {
	background-color: #fff !important;
}

.trz_fields.trz-custom-dropdown .btn-secondary
{
    width: 100px !important;
}

td input {
	z-index: 0 !important;
}

 
</style>  